var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFrame(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 8C2.25 8.41423 2.58579 8.75 3 8.75H9C9.41423 8.75 9.75 8.41423 9.75 8V3.5C9.75 3.08579 9.41423 2.75 9 2.75H3C2.58579 2.75 2.25 3.08579 2.25 3.5V8ZM8.25 15.5C8.25 15.9142 8.58577 16.25 9 16.25H15C15.4142 16.25 15.75 15.9142 15.75 15.5V11C15.75 10.5858 15.4142 10.25 15 10.25H9C8.58577 10.25 8.25 10.5858 8.25 11V15.5ZM9.75 11.75H14.25V14.75H9.75V11.75ZM2.25 15.5C2.25 15.9142 2.58579 16.25 3 16.25H6C6.41422 16.25 6.75 15.9142 6.75 15.5V11C6.75 10.5858 6.41422 10.25 6 10.25H3C2.58579 10.25 2.25 10.5858 2.25 11V15.5ZM3.75 14.75V11.75H5.25V14.75H3.75ZM3.75 7.25V4.25H8.25V7.25H3.75ZM15 8.75C15.4142 8.75 15.75 8.41423 15.75 8V3.5C15.75 3.08579 15.4142 2.75 15 2.75H12C11.5858 2.75 11.25 3.08579 11.25 3.5V8C11.25 8.41423 11.5858 8.75 12 8.75H15ZM14.25 7.25H12.75V4.25H14.25V7.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame);
export default __webpack_public_path__ + "static/media/Frame.6e82ec4076a0dc26ba042112a98f619e.svg";
export { ForwardRef as ReactComponent };